let ref = null
function setRefDom(refDom){
    ref = refDom 
}
function getRefDom(){
    return ref
}
export default {setRefDom, getRefDom}